<template>
  <section id="about" class="about">
    <div>
      <div class="section-title">
        <h2>研究方向、國際證照(Research & Certification)</h2>
      </div>
      <hr />
      <h2 class="research-title">Research Topics</h2>
      <hr />
      <p class="research-content" v-for="(item, key) in reserach" :key="key">
        {{ key + 1 }}. {{ item }}
      </p>
      <hr />
      <h2 class="research-title">CERTIFICATIONS (NCUT:1019)</h2>
      <hr />
      <p class="certifications-content" v-for="item1 in cert" :key="item1.num">
        <a class="ct1">{{ item1.num }}</a>
        <a v-if="item1.path.includes('.png')" class="ct2">{{ item1.name }}</a>
        <a v-else class="ct2" :href="item1.path" target="_blank">{{
          item1.name
        }}</a>
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.certi_num }}</a>
      </p>
      <hr />
    </div>
  </section>
</template>

<script>
import { certifications_111 } from "../assets/certificationsRouter/certifications_111";
import { certifications_112 } from "../assets/certificationsRouter/certifications_112";
export default {
  name: "research",
  data() {
    return {
      reserach: [
        "Cyber Security; Steganography; Visual Cryptography; Multimedia, Database; Network Security.",
        "Block Chain Applications; Big Data; Machine Learning; Deep Learning; Privacy Preserving.",
        "AR/VR/SR/MR Design; Game programming (ShiVa3D, Unity, ActionScript, JavaScript, C#, C++).",
        "Intelligent Living Technology; RFID; Sensor Network; Mobile Applications.",
        "Wireless Personal Area Network; Wireless Communication; Ad-hoc Network.",
      ],
      cert: [
        {
          num: "(99900182)",
          name: "Visual Communication",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120250610010001)(2025/06/12)",
          path: "",
        },
		    {
          num: "(10199183)",
          name: "(PVQC)Professional Vocabulary Quotient Credential -ICT (Expert-Tier Four(含)以上)",
          ca: "((GLAD) Global Learning and Assessment Development)",
          certi_num: "(23G-PVQC-IC-E6-886017304)(2025/06/19)",
          path: "",
        },		
		    {
          num: "(99900180)",
          name: "ICT using Python Programming-Essentials",
          ca: "((GLAD) Global Learning and Assessment Development)",
          certi_num: "(PV531202510979)(2025/06/25)",
          path: "",
        },
		    {
          num: "(99900103)",
          name: "Big Data Database:NoSQL",
          ca: "(Silicon Stone Education",
          certi_num: "(00310120250610030001)(2025/06/16)",
          path: "",
        },
		    {
          num: "(99900132)",
          name: "(PVQC)Professional Vocabulary Quotient Credential -AI (Expert-Tier Four(含)以上)",
          ca: "((GLAD) Global Learning and Assessment Development [全球學習與測評發展中心]",
          certi_num: "(23G-PVQC-AI-E5-886009211)(2024/07/30)",
          path: "",
        },
		    {
          num: "(101912629)",
          name: "User Interface Design",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120240425030001)(2024/06/05)",
          path: "",
        },
		    {
          num: "(101910695)",
          name: "SAS Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120240425010001)(2024/05/25)",
          path: "",
        },
		    {
          num: "(101912613)",
          name: "Chromatics",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120240425020001)(2024/05/21)",
          path: "",
        },
		    {
          num: "(99900158)",
          name: "Develop, Customize, and Publish in Omniverse With Extensions",
          ca: "(NVIDIA Deep Learning Institute)",
          certi_num: "(07567393ae7f4753a18db9df9ad85ade)(2024/01/21)",
          path: "",
        },
        {
          num: "(10199348)",
          name: "Computer Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120230603010001)(2023/06/06)",
          path: certifications_112[0],
        },
        {
          num: "(99900155)",
          name: "Professional Vocabulary Quotient Credential- AI Literacy Specialist(專業)",
          ca: "(GLAD)",
          certi_num: "(22B-PVQC-AI-SS-886108203)(2023/06/04)",
          path: certifications_112[1],
        },
        {
          num: "(99900130)",
          name: "Artificial Intelligence Literacy Certification Programs 人工智慧素養國際認證 Specialist(專業)",
          ca: "(GLAD)",
          certi_num: "(23-A-AIL-00-SP-886000806)(2023/06/04)",
          path: certifications_112[2],
        },
        {
          num: "(99900156)",
          name: "Disaster Risk Montioring UsingSatellite Imagery",
          ca: "(NVIDIA)",
          certi_num: "(b6a888127c294a12b0f35cb188f3e63f)(2023/01/28)",
          path: certifications_112[3],
        },
        {
          num: "(99900157)",
          name: "Statistical Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120230605010001)(2023/07/07)",
          path: certifications_112[4],
        },
        {
          num: "(*****)",
          name: "Cyber Security in Industrial Automation",
          ca: "(TÜV Rheinland (GC) Ltd.)",
          certi_num: "(#463/21)(2021/02)",
          path: certifications_111[0],
        },
        {
          num: "(*****)",
          name: "Artificial Intelligence Literacy Certification Programs Fundamentals",
          ca: "(GLAD)",
          certi_num: "(22-A-AIL-00-FD-886000800)(2021/07/10)",
          path: certifications_111[1],
        },
        {
          num: "(*****)",
          name: "Artificial Intelligence Literacy Certification Programs Expert",
          ca: "(GLAD)",
          certi_num: "(22-A-AIL-00-FD-886000801)(2022/07/10)",
          path: certifications_111[2],
        },
        {
          num: "(*****)",
          name: "Information and Communication Technology Certification Programs-Essentials level",
          ca: "(GLAD)",
          certi_num: "(18-A-ICT-00-ES-886000330)(2018/03/10 )",
          path: certifications_111[3],
        },
        {
          num: "(99900099)",
          name: "MaPP(Mobile apps Programming Professionals)using APP Inventor (Ver. 2 or Classic)",
          ca: "(GLAD)",
          certi_num: "(19A-MPPF-AP-MF-886100019)(2019/6/24)",
          path: certifications_111[4],
        },
        {
          num: "(99900125)",
          name: "Building Video AI Applications at the Edge on Jetson Nano",
          ca: "(NVIDIA)",
          certi_num: "(85453372499a41afa9d27e2274847937)(2022/1/13)",
          path: certifications_111[5],
        },
        {
          num: "(10971)",
          name: "Adobe After Effects",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120220527030002)(2022/7/9)",
          path: certifications_111[6],
        },
        {
          num: "(12394)",
          name: "Auto CAD Essential",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120220527040002)(2022/7/9)",
          path: certifications_111[7],
        },
        {
          num: "(9625)",
          name: "Data Power Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120220527010001)(2022/6/4)",
          path: certifications_111[8],
        },
        {
          num: "(99900124)",
          name: "Machine Learning Essential",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120220527020001)(2022/5/27)",
          path: certifications_111[9],
        },
        {
          num: "(8024)",
          name: "iCritical Thinking (資訊決策思考力國際認證)",
          ca: "(Certiport.Powered by ETS)",
          certi_num: "(9MK7-kPVd)",
          path: certifications_111[10],
        },
        {
          num: "(4185)",
          name: "CCNA (200-125)",
          ca: "(CISCO)",
          certi_num: "(429011205263JODH)(2017/06/15)",
          path: certifications_111[11],
        },
        {
          num: "(7354)",
          name: "CompTIA RFID+",
          ca: "(CompTIA)",
          certi_num: "(COMP001020320261,F7GMVSCK5HVE2RQX)",
          path: certifications_111[12],
        },
        {
          num: "(2273)",
          name: "CompTIA Security+ ce",
          ca: "(CompTIA)",
          certi_num: "(COMP001020320261, S59V4WMLQK41Q703)",
          path: certifications_111[13],
        },
        {
          num: "(2271)",
          name: "CompTIA Network+ ce",
          ca: "(CompTIA)",
          certi_num: "(COMP001020320261, J6KDPHDDRPQ1KZPV)",
          path: certifications_111[14],
        },
        {
          num: "(2271)",
          name: "CompTIA Network+",
          ca: "(CompTIA)",
          certi_num: "(COMP001020320261, 3KJ25ZG16DV1YFD5)",
          path: certifications_111[15],
        },
        {
          num: "(8022)",
          name: "CompTIA Project+",
          ca: "(CompTIA)",
          certi_num: "(COMP001020320261, 2R76FBXC9CE414YD)",
          path: certifications_111[16],
        },
        {
          num: "(8075)",
          name: "OCPJP7",
          ca: "(Oracle Certified Professional, Java SE 7 Programmer)",
          certi_num: "(219907858OCPJSE7)",
          path: certifications_111[17],
        },
        {
          num: "(7086)",
          name: "OCPJP6",
          ca: "(Oracle Certified Professional, Java SE 6 Programmer)",
          certi_num: "(219907858OCPJSE6P)",
          path: certifications_111[18],
        },
        {
          num: "(4262)",
          name: "SCJP",
          ca: "(SUN Certified Programmer for the Java Platform)",
          certi_num: "(Oracle:SR2138535)",
          path: certifications_111[19],
        },
        {
          num: "(9990—-)",
          name: "Building Video AI Applications at the Edge on Jetson Nano",
          ca: "(NVIDIA Deep Learning Institute)",
          certi_num: "(85453372499a41afa9d27e2274847937)(2022/01/13)",
          path: certifications_111[20],
        },
        {
          num: "(99900116)",
          name: "Microsoft Certified:Azure AI Fundamentals",
          ca: "(Microsoft)",
          certi_num: "(H913-8282)(2021/07/30)",
          path: certifications_111[21],
        },
        {
          num: "(10970)",
          name: "Adobe Premiere CC ",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120210716020001)(2021/07/20)",
          path: certifications_111[22],
        },
        {
          num: "(12334)",
          name: "Adobe InDesign CC",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120210719010004)(2021/08/03)",
          path: certifications_111[23],
        },
        {
          num: "(99900114)",
          name: "Getting Started With DeepStream For Video On Jetson Nano",
          ca: "(NVIDIA Deep Learning Institute) ",
          certi_num: "(f06e9650f8f24ab7ae0dda7c95bde416)(2021/07/05)",
          path: certifications_111[24],
        },
        {
          num: "(99900109)",
          name: "Getting Started With AI On Jetson Nano",
          ca: "(NVIDIA Deep Learning Institute)",
          certi_num: "(8e1afae8e2a14ef9bf5c41491e329458)(2020/10/14)",
          path: certifications_111[25],
        },
        {
          num: "(99900102)",
          name: "Artificial Intelligence Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120191001060001)(2019-10-02)",
          path: certifications_111[26],
        },
        {
          num: "(99900101)",
          name: "Artificial Intelligence Essentials",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120191001050001)(2019-10-02)",
          path: certifications_111[27],
        },
        {
          num: "(99900103)",
          name: "Big Data Database:NoSQL",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120191001010001)(2019-10-02)",
          path: certifications_111[28],
        },
        {
          num: "(99900104)",
          name: "Data Analysis Using Excel",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120191001020001)(2019-10-05)",
          path: certifications_111[29],
        },
        {
          num: "(99900100)",
          name: "Web Design Using HTML5",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120191001030001)(2019-10-04)",
          path: certifications_111[30],
        },
        {
          num: "(10694)",
          name: "Big Data Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120180713030001)(2018/07/18)",
          path: certifications_111[31],
        },
        {
          num: "(99900042)",
          name: "Python Language Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120180713040001)(2018/07/18)",
          path: certifications_111[32],
        },
        {
          num: "(99900041)",
          name: "C Language Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120180713020001)(2018/07/18)",
          path: certifications_111[33],
        },
        {
          num: "(10696)",
          name: "R Language Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120181029040002)(2018/11/22)",
          path: certifications_111[34],
        },
        {
          num: "(99900040)",
          name: "Java Language Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120180911020001)(2018/09/11)",
          path: certifications_111[35],
        },
        {
          num: "(12629)",
          name: "User Interface Design",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120200904010001)(2020/09/05)",
          path: certifications_111[36],
        },
        {
          num: "(10973)",
          name: "Big Data Infrastructure : Hadoop",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120200331010001)(2020/09/08)",
          path: certifications_111[37],
        },
        {
          num: "(12332)",
          name: "Adobe Dreamweaver CC",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120200320010001)(2020/03/24)",
          path: certifications_111[38],
        },
        {
          num: "(10695)",
          name: "SAS Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120200511030001)(2020/09/05)",
          path: certifications_111[39],
        },
        {
          num: "(99900111)",
          name: "Linux Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120200904030001)(2020/09/05)",
          path: certifications_111[40],
        },
        {
          num: "(*****)",
          name: "Cinema 4D Essential",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120200904020001)(2020/09/06)",
          path: certifications_111[41],
        },
        {
          num: "(99900110)",
          name: "CSS3 Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120191009010001)(2020/09/06)",
          path: certifications_111[42],
        },
        {
          num: "(99900099)",
          name: "(MaPP) Mobile apps Programming Professionals",
          ca: "(GLAD)",
          certi_num: "(19A-MPPF-AP-MF-886100019)(kzak-bomt)(2019/06/24)",
          path: certifications_111[43],
        },
        {
          num: "(8999)",
          name: "ICT-Essential level",
          ca: "(GLAD)",
          certi_num: "(18-A-ICT-00-ES-886000330)(rykg-anae)(2018/03/10)",
          path: certifications_111[44],
        },
        {
          num: "(8485)",
          name: "CIW Web Security Associate",
          ca: "(CIW: Certified Internet Web Professional)",
          certi_num: "(770049)(2017/03/31)",
          path: certifications_111[45],
        },
        {
          num: "(7461)",
          name: "DLink- DNA",
          ca: "(DNA – DNA D-Link Network Associate)",
          certi_num: "(DNA-NWF000071)",
          path: certifications_111[46],
        },
        {
          num: "(8141)",
          name: "HP ATA – Cloud",
          ca: "(ExperOne – Accredited Technical Associate)",
          certi_num: "(wbp7R-HaCL)",
          path: certifications_111[47],
        },
        {
          num: "(8143)",
          name: "HP ATA – Networks",
          ca: "(ExperOne – Accredited Technical Associate)",
          certi_num: "(wmTch-4SXa)",
          path: certifications_111[48],
        },
        {
          num: "(8144)",
          name: "HP ATA – Connectd Devices",
          ca: "(ExperOne – Accredited Technical Associate)",
          certi_num: "(E8cJ-XL8C)",
          path: certifications_111[49],
        },
        {
          num: "(8142)",
          name: "HP ATA – Servers & Storage",
          ca: "(ExperOne – Accredited Technical Associate)",
          certi_num: "(dhAs-DToc)",
          path: certifications_111[50],
        },
        {
          num: "(7093)",
          name: "Juniper NetworksJNCIA-JUNOS",
          ca: "(Associate, JUNOS Certification)",
          certi_num: "(JPR107111)",
          path: certifications_111[51],
        },
        {
          num: "(7092)",
          name: "Juniper Networks JNCIS-SEC",
          ca: "(Specialist, JUNOS Security Certification)",
          certi_num: "(JPR107111)",
          path: certifications_111[52],
        },
        {
          num: "(2280)",
          name: "Juniper NetworksJNCIS-ER",
          ca: "(Specialist, Enterprise Routing Certification)",
          certi_num: "(JPR107111)",
          path: certifications_111[53],
        },
        {
          num: "(4315)",
          name: "Juniper Networks JNCIA-EX",
          ca: "(Associate, Enterprise Switching Certification)",
          certi_num: "(JPR107111)",
          path: certifications_111[54],
        },
        {
          num: "(2279)",
          name: "Juniper NetworksJNCIA-ER",
          ca: "(Associate, Enterprise Routing Certification)",
          certi_num: "(JPR107111)",
          path: certifications_111[55],
        },
        {
          num: "(1607)",
          name: "SPPA",
          ca: "(Association for Bridging the Information Divide)",
          certi_num: "(SPPA20112343)",
          path: certifications_111[56],
        },
        {
          num: "(9184)",
          name: "Prof.VocabularyQuotient Credential-ICT-Expert-Tier Five",
          ca: "(GLAD—",
          certi_num: "(14B-PVQC-IC-E5-886004967)",
          path: certifications_111[57],
        },
        {
          num: "(9349)",
          name: "Barista",
          ca: "(Silicon Stone Education)",
          certi_num: "(30000520140605030001)",
          path: certifications_111[58],
        },
        {
          num: "(9346)",
          name: "Tea Sppecialist",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120150330030001)",
          path: certifications_111[59],
        },
        {
          num: "(9336)",
          name: "Photography",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120150330010001)",
          path: certifications_111[60],
        },
        {
          num: "(10969)",
          name: "Adobe Photoshop CC",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120170222020001)(2017/02/22)",
          path: certifications_111[61],
        },
        {
          num: "(12333)",
          name: "Adobe Illustrator CC",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120170222010001)(2017/02/22)",
          path: certifications_111[62],
        },
        {
          num: "(10975)",
          name: "Designing 3D Animation Games Using 3D Studio Max",
          ca: "(Silicon Stone Education) ",
          certi_num: "(00310120170222040001)(2017/02/22)",
          path: certifications_111[63],
        },
        {
          num: "(10976)",
          name: "Designing 3D Animation Games Using Maya",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120170222030001)(2017/02/22)",
          path: certifications_111[64],
        },
        {
          num: "(10977)",
          name: "Designing 3D Animation Games Using Unity",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120160408010001)(2016/04/20)",
          path: certifications_111[65],
        },
        {
          num: "(12613)",
          name: "Chromatics(色彩學)",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120161013030001)(2016/10/14)",
          path: certifications_111[66],
        },
        {
          num: "(9629)",
          name: "Adobe Dreamweaver CS6",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120160523010001)(2016/05/23)",
          path: certifications_111[67],
        },
        {
          num: "(9629)",
          name: "Adobe Illustrator CS6",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120160512020001)(2016/05/23)",
          path: certifications_111[68],
        },
        {
          num: "(9628)",
          name: "Adobe Flash CS6",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120150330020001)",
          path: certifications_111[69],
        },
        {
          num: "(9348)",
          name: "Computer Knowledge Today",
          ca: "(Silicon Stone Education)",
          certi_num: "(00310120150512010001)",
          path: certifications_111[70],
        },
        {
          num: "(8150)",
          name: "ACA Flash CS6",
          ca: "(Rich Media Communication using Adobe Flash®)",
          certi_num: "(wbNP4-FM5M)",
          path: certifications_111[71],
        },
        {
          num: "(8223)",
          name: "ACA Photoshop CS6",
          ca: "(Visual Communication using Adobe Photoshop®)",
          certi_num: "(vJ2e-XV99)",
          path: certifications_111[72],
        },
        {
          num: "(8149)",
          name: "ACA Dreamweaver CS6",
          ca: "(Web Communication using Adobe Dreamweaver®)",
          certi_num: "(xXKk-s2zU)",
          path: certifications_111[73],
        },
        {
          num: "(7343)",
          name: "ACA Dreamweaver CS5",
          ca: "(Web Communication using Adobe Dreamweaver®)",
          certi_num: "(HHob-kdqv)",
          path: certifications_111[74],
        },
        {
          num: "(7344)",
          name: "ACA Flash CS5",
          ca: "(Rich Media Communication using Adobe Flash®)",
          certi_num: "(wvyoN-kpP3)",
          path: certifications_111[75],
        },
        {
          num: "(7152)",
          name: "ACA Photoshop CS5",
          ca: "(Visual Communication using Adobe Photoshop®)",
          certi_num: "(wv373-k5XJ)",
          path: certifications_111[76],
        },
        {
          num: "(3999)",
          name: "ACA Dreamweaver CS3",
          ca: "(Web Communication using Adobe Dreamweaver®)",
          certi_num: "(8rM-kqPU)",
          path: certifications_111[77],
        },
        {
          num: "(4000)",
          name: "ACA Flash CS3",
          ca: "(Rich Media Communication using Adobe Flash®)",
          certi_num: "(N7FV-woXw)",
          path: certifications_111[78],
        },
        {
          num: "(4001)",
          name: "ACA Photoshop CS3",
          ca: "(Visual Communication using Adobe Photoshop®)",
          certi_num: "(YPDh-kTV2)",
          path: certifications_111[79],
        },
        {
          num: "(479)",
          name: "MCP",
          ca: "(Microsoft Certified Professional)",
          certi_num: "(E073-8301)",
          path: certifications_111[80],
        },
        {
          num: "(2675)",
          name: "MCT",
          ca: "Microsoft Certified Trainer",
          certi_num: "(H589-2317)(2020/12/01)",
          path: certifications_111[81],
        },
        {
          num: "(9392)",
          name: "MCE",
          ca: "Microsoft Technology Literacy for Educators (ICT) (Exam 62-193)",
          certi_num: "(E782-2200)",
          path: certifications_111[82],
        },
        {
          num: "(11359)",
          name: "MS: Developing Microsoft Azure Solutions",
          ca: "(Exam 70-532)-(F541-7704)",
          certi_num: "",
          path: certifications_111[83],
        },
        {
          num: "(11360)",
          name: "MS: Implementing Microsoft Azure Infrastructure Solutions",
          ca: "(70-533)-(F545-2284)",
          certi_num: "",
          path: certifications_111[84],
        },
        {
          num: "(*****)",
          name: "MS: Administering Microsoft SQL Server 2012",
          ca: "(Exam 70-462)",
          certi_num: "",
          path: certifications_111[85],
        },
        {
          num: "(8628)",
          name: "",
          ca: "(Microsoft Certified Solutions Developer)",
          certi_num: "(E351-6190)",
          path: certifications_111[86],
        },
        {
          num: "◎(8163)",
          name: "MS: Programming in HTML5 with JavaScript and CSS3",
          ca: "(Exam 480)",
          certi_num: "(E198-0358)",
          path: certifications_111[87],
        },
        {
          num: "",
          name: "◎MS: Developing ASP.NET MVC Web Applications",
          ca: "(Exam 486)",
          certi_num: "(passed)",
          path: certifications_111[88],
        },
        {
          num: "",
          name: "◎MS: Developing Windows Azure and Web Services",
          ca: "(Exam 487)",
          certi_num: "(passed)",
          path: certifications_111[89],
        },
        {
          num: "(11358)",
          name: "MCSA: Office 365",
          ca: "(Microsoft Certified Solutions Associate)",
          certi_num: "(F111-1705)",
          path: certifications_111[90],
        },
        {
          num: "",
          name: "◎MS: Managing Office 365 Identities and Requirements",
          ca: "(Exam 70-346)",
          certi_num: "(passed)",
          path: certifications_111[91],
        },
        {
          num: "",
          name: "◎MS: Enabling Office 365 Services",
          ca: "(Exam 70-347)",
          certi_num: "(passed)",
          path: certifications_111[92],
        },
        {
          num: "(8832)",
          name: "MS: Programming in c#",
          ca: "(Exam 483) ",
          certi_num: "(F063-2649)",
          path: certifications_111[93],
        },
        {
          num: "(10931)",
          name: "MTA: Cloud Fundamentals",
          ca: "(98-369)",
          certi_num: "(F224-8302/8298419)",
          path: certifications_111[94],
        },
        {
          num: "(10932)",
          name: "MTA: Mobility and Device Fundamentals",
          ca: "(98-368)",
          certi_num: "(F189-5904/8298419)",
          path: certifications_111[95],
        },
        {
          num: "(9569)",
          name: "MTA: Software Testing Fundamental",
          ca: "(98-379)",
          certi_num: "(E804-2578/8298419)",
          path: certifications_111[96],
        },
        {
          num: "(7364)",
          name: "MTA: Windows® Operating System Fundamentals",
          ca: "(98-349)",
          certi_num: "(D264-7484/8298419)",
          path: certifications_111[97],
        },
        {
          num: "(7146)",
          name: "MTA: Software Development Fundamentals",
          ca: "(98-361) ",
          certi_num: "(D375-1256/8298419)",
          path: certifications_111[98],
        },
        {
          num: "(7294)",
          name: "MTA: Windows Development Fundamentals",
          ca: "(98-362)",
          certi_num: "(D503-6898: 8298419)",
          path: certifications_111[99],
        },
        {
          num: "(7295)",
          name: "MTA: Web Development Fundamentals",
          ca: "(98-363) ",
          certi_num: "(D375-1257/8298419)",
          path: certifications_111[100],
        },
        {
          num: "(7145)",
          name: "MTA: Database Administration Fundamentals",
          ca: "(98-364)",
          certi_num: "(D268-4785/8298419)",
          path: certifications_111[101],
        },
        {
          num: "(7296)",
          name: "MTA: Windows® Server Administration Fundamentals",
          ca: "(98-365)",
          certi_num: "(D375-1258/8298419)",
          path: certifications_111[102],
        },
        {
          num: "(7109)",
          name: "MTA: Networking Fundamentals",
          ca: "(98-366)",
          certi_num: "(D264-7482/8298419)",
          path: certifications_111[103],
        },
        {
          num: "(7297)",
          name: "MTA: Security Fundamentals",
          ca: "(98-367)",
          certi_num: "(D264-7483/8298419)",
          path: certifications_111[104],
        },
        {
          num: "(7450)",
          name: "MTA: .NET Fundamentals",
          ca: "(98-372)",
          certi_num: "(D503-6897/8298419)",
          path: certifications_111[105],
        },
        {
          num: "(7858)",
          name: "MTA: Mobile Development Fundamentals",
          ca: "(98-373) ",
          certi_num: "(E179-2443/8298419)",
          path: certifications_111[106],
        },
        {
          num: "(7783)",
          name: "MTA: Gaming Development Fundamentals",
          ca: "(98-374) ",
          certi_num: "(E010-8625/8298419)",
          path: certifications_111[107],
        },
        {
          num: "(8023)",
          name: "MTA: HTML5 Application Development Fundamentals",
          ca: "(98-375)",
          certi_num: "(D924-8911/8298419)",
          path: certifications_111[108],
        },
        {
          num: "(7852)",
          name: "Microsoft Office Specialist Master 2010—",
          ca: "",
          certi_num: "(vqKC-XVYe)",
          path: certifications_111[109],
        },
        {
          num: "(7850)",
          name: "Microsoft Office Specialist for Office Access 2010",
          ca: "",
          certi_num: "(EeCb-XLe2)",
          path: certifications_111[110],
        },
        {
          num: "(7632)",
          name: "Microsoft Office Specialist for Office PowerPoint 2010 ",
          ca: "",
          certi_num: "(wuysL-k8Bu)",
          path: certifications_111[111],
        },
        {
          num: "(7706)",
          name: "Microsoft Office Specialist Expert for Office Word 2010 Expert—",
          ca: "",
          certi_num: "(vAoV-kPVJ)",
          path: certifications_111[112],
        },
        {
          num: "(7425)",
          name: "Microsoft Office Specialist Expert for Office Excel 2010 Expert—",
          ca: "",
          certi_num: "(Ghh5-uG4r)",
          path: certifications_111[113],
        },
        {
          num: "(6787)",
          name: "Microsoft Office Specialist Expert for Office Word 2007 Expert",
          ca: "",
          certi_num: "(KLEC-kX8S)",
          path: certifications_111[114],
        },
        {
          num: "(7108)",
          name: "IC³ Certification – Global Standard 3",
          ca: "",
          certi_num: "(APQN-wQey)",
          path: certifications_111[115],
        },
        {
          num: "◎(6939) ",
          name: "",
          ca: "IC³ Global Standard 3 (GS3) – Computing Fundamentals",
          certi_num: "(kB56-kMsN)",
          path: certifications_111[116],
        },
        {
          num: "◎(6941)",
          name: "",
          ca: "IC³ Global Standard 3 (GS3) – Key Applications",
          certi_num: "(kdov-ws35)",
          path: certifications_111[117],
        },
        {
          num: "◎(6940)",
          name: "",
          ca: "IC³ Global Standard 3 (GS3) – Living Online",
          certi_num: "(YNkv-kxQE)",
          path: certifications_111[118],
        },
        {
          num: "(3994)",
          name: "IC³ Certification",
          ca: "(Internet and Computing Core Certification)",
          certi_num: "(ksSY-wsSy)",
          path: certifications_111[119],
        },
        {
          num: "◎(6939)",
          name: "",
          ca: "IC³ 2005 – Computing Fundamentals",
          certi_num: "(NHXU-wo9c)",
          path: certifications_111[120],
        },
        {
          num: "◎(6941)",
          name: "",
          ca: "IC³ 2005 – Key Applications",
          certi_num: "(AdNP-wWVx)",
          path: certifications_111[121],
        },
        {
          num: "◎(6940)",
          name: "",
          ca: "IC³ 2005 – Living Online",
          certi_num: "(YdKz-w7B9)",
          path: certifications_111[122],
        },
        {
          num: "(7229)",
          name: "Reallusion iClone Producer",
          ca: "",
          certi_num: "(100262)",
          path: certifications_111[123],
        },
        {
          num: "(5404)",
          name: "Reallusion iClone Designer",
          ca: "",
          certi_num: "(100335)",
          path: certifications_111[124],
        },
        {
          num: "(7682)",
          name: "Reallusion iClone Instructor",
          ca: "",
          certi_num: "(100352)",
          path: certifications_111[125],
        },
        {
          num: "(7229)",
          name: "Reallusion CrazyTalk Producer ",
          ca: "",
          certi_num: "(110001)",
          path: certifications_111[126],
        },
        {
          num: "(5404) ",
          name: "Reallusion CrazyTalk Designer ",
          ca: "",
          certi_num: "(110057)",
          path: certifications_111[127],
        },
        {
          num: "(7682)",
          name: "Reallusion CrazyTalk Instructor",
          ca: "",
          certi_num: "(110058)",
          path: certifications_111[128],
        },
        {
          num: "(9585)",
          name: "Microsys Solution Certified Specialist – Network, Infrastructure",
          ca: "",
          certi_num: "(1A8BA88A)",
          path: certifications_111[129],
        },
        {
          num: "(9584)",
          name: "Microsys Solution Certified Specialist – Linux, Configuring",
          ca: "",
          certi_num: "(1E8CA66A)",
          path: certifications_111[130],
        },
        {
          num: "(9583)",
          name: "Microsys Solution Certified Specialist – Essential of HTML5 Programming",
          ca: "",
          certi_num: "(1E8CE77F)",
          path: certifications_111[131],
        },
        {
          num: "(9586)",
          name: "Microsys Solution Certified Specialist – BIG Data, Configuring",
          ca: "",
          certi_num: "(1142018)",
          path: certifications_111[132],
        },
        {
          num: "(9798)",
          name: "Microsys Solution Certified Professional – Human-Computer Interface Design",
          ca: "",
          certi_num: "(168A7887)",
          path: certifications_111[133],
        },
        {
          num: "(9586)",
          name: "Microsys Solution Certified Specialist – BIG Data",
          ca: "(320020)",
          certi_num: "",
          path: certifications_111[134],
        },
        {
          num: "(****)",
          name: "Microsys Solution Certified Specialist – Data Mining Analyst ",
          ca: "",
          certi_num: "(3142032)",
          path: certifications_111[135],
        },
        {
          num: "(****)",
          name: "Microsys Solution Certified Specialist – Statistics Analyst",
          ca: "",
          certi_num: "(2142020)",
          path: certifications_111[136],
        },
        {
          num: "(****)",
          name: "Microsys Solution Certified Professional – Advanced Data Mining Analyst",
          ca: "",
          certi_num: "(6142131)",
          path: certifications_111[137],
        },
        {
          num: "(****)",
          name: "Microsys Solution Certified Professional – Advanced Statistics Analyst",
          ca: "",
          certi_num: "(5142129)",
          path: certifications_111[138],
        },
        {
          num: "(****)",
          name: "Microsys Solution Certified Professional – Advanced BIG DATA",
          ca: "",
          certi_num: "(4142117)",
          path: certifications_111[139],
        },
        {
          num: "",
          name: "◎ PVQC Authorized Proctor ",
          ca: "(Professional Vocabulary Quotient Credential Programs for GLAD)",
          certi_num: "(019908862016000249)",
          path: certifications_111[140],
        },
        {
          num: "",
          name: "◎ (8767)PVTC_A",
          ca: "(PearsonVUE CertifiedAdministrator)—",
          certi_num: "(C_ID:VUE1252000,R_ID:262813996)",
          path: certifications_111[141],
        },
        {
          num: "",
          name: "◎ HP-ATA Authorized Proctor/Lecture",
          ca: "",
          certi_num: "(Elite instructor for HP-ATA)",
          path: certifications_111[142],
        },
        {
          num: "",
          name: "◎ ACA Authorized Proctor",
          ca: "(Certiport Proctor for ACA)",
          certi_num: "(029208862010000158)",
          path: certifications_111[143],
        },
        {
          num: "",
          name: "◎ IC3 Authorized Proctor",
          ca: "(Certiport Proctor for IC3)",
          certi_num: "(079208862010000167)",
          path: certifications_111[144],
        },
        {
          num: "",
          name: "◎ MTA Authorized Proctor",
          ca: "(Certiport Proctor for MTA)",
          certi_num: "(089208862011000081)",
          path: certifications_111[145],
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}
@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC_Regular", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
  cursor: pointer;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.ct1 {
  color: rgb(103, 38, 146);
}
.ct2 {
  color: blue;
}
.ct3 {
  color: coral;
}
.ct4 {
  color: red;
}
.ct5 {
  color: rgb(4, 174, 173);
}
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}

.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  font-family: "NotoSansTC_Bold";
  text-align: center;
  padding-bottom: 30px;
}
.section-title h2 {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #555;
}
.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# publicaiton
--------------------------------------------------------------*/
.research-title {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 3vh;
  text-align: center;
}
.research-content {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #065654;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}
.about ul {
  list-style: none;
  padding: 0;
}
.about ul li {
  padding-bottom: 10px;
}
.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}
.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
